import { messageTypeByFileType } from '$func/file'
import {
  MESSAGE_CAPTION_SIZE,
  MESSAGE_BODY_SIZE,
  isDownloadableMessage,
} from '$logic/message'
import {
  showMaxCharacterInCaptionReachedErrorSnackbar,
  showMaxCharacterInTextReachedErrorSnackbar,
} from '$comp/snackbars'
import { SendFieldAction } from '$comp/_app/components/chat/components/footer/components/send-field/send-field.type'

export function changeFileTypeToValidFileOrAudioMessageType(file: File) {
  if (['FILE', 'AUDIO'].includes(messageTypeByFileType(file.type))) return file
  return new File([file], file.name, { type: '' })
}

export function checkIfFileIsAMedia(file: File | undefined) {
  if (!file) return false
  const type = messageTypeByFileType(file.type)

  return ['IMAGE', 'VIDEO'].includes(messageTypeByFileType(file.type))
}

export function checkMessageBodySizeHasError(
  body: string,
  action: SendFieldAction,
  file?: File | undefined,
) {
  // NOTE: During send new message with attachment file value is available
  // but during editing caption of a message, value of file variable is null

  if (!body) return false

  if (file) {
    if (body.length > MESSAGE_CAPTION_SIZE) {
      // NOTE: if message has attachment so caption must be less than MESSAGE_CAPTION_SIZE | During reply or edit or sending new message
      showMaxCharacterInCaptionReachedErrorSnackbar()
      return true
    }
    return false
  }

  if (action.type === 'EDIT') {
    if (
      isDownloadableMessage(action.message.type)
      // 'IMAGE', 'FILE', 'VIDEO', 'AUDIO', 'VOICE'
    ) {
      if (body.length > MESSAGE_CAPTION_SIZE) {
        // NOTE: during editing if file had attachment so new caption must be less than MESSAGE_CAPTION_SIZE
        showMaxCharacterInCaptionReachedErrorSnackbar()
        return true
      }
      return false
    }
    if (body.length > MESSAGE_BODY_SIZE) {
      // NOTE: if message has no attachment so text must be less than MESSAGE_BODY_SIZE | Just During edit
      showMaxCharacterInTextReachedErrorSnackbar()
      return true
    }
  }
  return false
}
